<script setup lang="ts">
import { DialogContent, DialogOverlay, DialogPortal, DialogRoot } from 'reka-ui'

/** A centred modal: traps focus, closes on Escape and outside click, and returns focus to its opener. */
defineProps<{ open: boolean; label: string }>()
const emit = defineEmits<{ close: []; 'close-auto-focus': [event: Event] }>()

function onOpenChange(next: boolean): void {
  if (!next) emit('close')
}

function keepPickerOpen(event: CustomEvent<{ originalEvent: PointerEvent }>): void {
  const target = event.detail.originalEvent.target
  if (target instanceof Element && target.closest('[role="listbox"]') !== null) event.preventDefault()
}
</script>

<template>
  <DialogRoot :open="open" @update:open="onOpenChange">
    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-40 bg-[color:var(--color-text)]/40 data-[state=closed]:animate-overlay-out data-[state=open]:animate-overlay-in"
      />
      <DialogContent
        :aria-label="label"
        :aria-describedby="undefined"
        @pointer-down-outside="keepPickerOpen"
        @close-auto-focus="emit('close-auto-focus', $event)"
        class="fixed left-1/2 top-1/2 z-50 flex max-h-[88vh] w-[min(44rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 flex-col overflow-y-auto rounded-[var(--radius-overlay)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] shadow-[var(--shadow-dialog)] focus:outline-none data-[state=closed]:animate-overlay-out data-[state=open]:animate-dialog-in motion-reduce:data-[state=open]:animate-overlay-in"
      >
        <slot />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
